import { breadcrumbRoot } from "@modules/breadcrumb/breadcrumb"
import { afterApiFetched } from "@modules/news/after-api-fetched.ts"
import { fetchApi } from "@modules/news/api.ts"
import { getPage, setPage } from "./pagination"

export async function onPaginationSelectClick(
    event: MouseEvent,
    select: HTMLSelectElement | null,
    scrollToBreadcrumb = false,
) {
    if (!(event.target instanceof HTMLElement)) {
        return
    }

    const value = Number.parseInt(select?.value || "-1")
    if (value === -1) {
        return
    }
    if (getPage() === value) {
        return
    }

    setPage(value)
    await afterApiFetched(await fetchApi())
    if (scrollToBreadcrumb) {
        breadcrumbRoot()?.scrollIntoView({ behavior: "smooth" })
    }
}
